export default "__VITE_ASSET__VcUxA82$__"